import React from "react";
import { Reveal } from "./Reveal";
import { LucideIcon } from "./LucideIcon";
import { AUDIENCE } from "@/data";

export const Audience = () => {
  return (
    <section id="audience" data-testid="audience-section" className="relative py-24 md:py-32 bg-sf-surface/30">
      <div className="w-full max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-8 bg-sf-ember" />
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-sf-ember">Who This Is For</span>
          </div>
          <h2 className="sf-stencil text-4xl md:text-5xl text-sf-bone max-w-3xl leading-[1.05]">
            Spiritual warriors in real-world roles.
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {AUDIENCE.map((a, i) => (
            <Reveal key={a.title} delay={i * 0.06}>
              <div
                data-testid="audience-grid-card"
                className="group h-full bg-sf-surface border border-sf-border rounded-md p-7 transition-all duration-300 hover:border-sf-ember/60 hover:bg-sf-surfaceHover"
              >
                <div className="h-11 w-11 rounded-sm border border-sf-border flex items-center justify-center text-sf-ember group-hover:border-sf-ember/60 transition-colors">
                  <LucideIcon name={a.icon} size={22} strokeWidth={1.6} />
                </div>
                <h3 className="mt-5 sf-stencil text-xl tracking-wide text-sf-bone">{a.title}</h3>
                <p className="mt-2 text-sm text-sf-dim leading-relaxed">{a.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-12 max-w-3xl text-base md:text-lg text-sf-dim leading-relaxed">
            Even if you’ve never worn a uniform — if you’ve held space for others or worked in the
            dark, <span className="text-sf-bone">you’re part of this frontline too.</span>
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default Audience;
